// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Please enter a valid date`
};

const de_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte gib ein gültiges Datum ein`
};

const es_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor ingresa una fecha válida`
};

const fr_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Veuillez entrer une date valide`
};

const fi_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Anna kelvollinen päivämäärä`
};

const hi_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `कृपया एक वैध तारीख दर्ज करें`
};

const ja_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `有効な日付を入力してください`
};

const nl_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Voer een geldige datum in`
};

const pt_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, insira uma data válida`
};

const ro_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Te rugăm să introduci o dată validă`
};

const th_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `กรุณากรอกวันที่ที่ถูกต้อง`
};

const ur_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `براہ کرم درست تاریخ درج کریں`
};

const zh_hant1_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `請輸入有效的日期`
};

const da_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Indtast venligst en gyldig dato`
};

const it_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Inserisci una data valida`
};

const vn_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Vui lòng nhập ngày hợp lệ`
};

const ko_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `유효한 날짜를 입력해주세요`
};

const tr_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Lütfen geçerli bir tarih girin`
};

const lv_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Lūdzu, ievadiet derīgu datumu`
};

const ar_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `يرجى إدخال تاريخ صحيح`
};

const bs_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Molimo unesite važeći datum`
};

const sl_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Prosimo, vnesite veljaven datum`
};

const id_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Masukkan tanggal yang valid`
};

const sv_widget_login_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `Vänligen ange ett giltigt datum`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_invalid_date = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_invalid_date(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_invalid_date", locale)
	if (locale === "en") return en_widget_login_invalid_date(inputs)
	if (locale === "de") return de_widget_login_invalid_date(inputs)
	if (locale === "es") return es_widget_login_invalid_date(inputs)
	if (locale === "fr") return fr_widget_login_invalid_date(inputs)
	if (locale === "fi") return fi_widget_login_invalid_date(inputs)
	if (locale === "hi") return hi_widget_login_invalid_date(inputs)
	if (locale === "ja") return ja_widget_login_invalid_date(inputs)
	if (locale === "nl") return nl_widget_login_invalid_date(inputs)
	if (locale === "pt") return pt_widget_login_invalid_date(inputs)
	if (locale === "ro") return ro_widget_login_invalid_date(inputs)
	if (locale === "th") return th_widget_login_invalid_date(inputs)
	if (locale === "ur") return ur_widget_login_invalid_date(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_invalid_date(inputs)
	if (locale === "da") return da_widget_login_invalid_date(inputs)
	if (locale === "it") return it_widget_login_invalid_date(inputs)
	if (locale === "vn") return vn_widget_login_invalid_date(inputs)
	if (locale === "ko") return ko_widget_login_invalid_date(inputs)
	if (locale === "tr") return tr_widget_login_invalid_date(inputs)
	if (locale === "lv") return lv_widget_login_invalid_date(inputs)
	if (locale === "ar") return ar_widget_login_invalid_date(inputs)
	if (locale === "bs") return bs_widget_login_invalid_date(inputs)
	if (locale === "sl") return sl_widget_login_invalid_date(inputs)
	if (locale === "id") return id_widget_login_invalid_date(inputs)
	if (locale === "sv") return sv_widget_login_invalid_date(inputs)
	return "widget_login_invalid_date"
};